module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Sport Space Gray + Black Open.ef7b4189.png";